import InstallGenerator from './InstallGenerator';

export default InstallGenerator;
